export const filterOptions = [
  {
    label: "Protocolo",
    value: "protocol"
  },
  {
    label: "Período",
    value: "date"
  },
  {
    label: "Status",
    value: "statusDemand"
  },
  {
    label: "Assunto",
    value: "typeClass"
  }
]

export const statusOptions = [
  {
    label: "Fechado",
    value: "FECHADO"
  },
  {
    label: "Aberto",
    value: "ABERTO"
  }
]

export const serviceOptions = [
  {
    label: "Solicitação",
    value: "SOLICITACAO"
  },
  {
    label: "Reclamação",
    value: "RECLAMACAO"
  },
  {
    label: "Informação",
    value: "INFORMACAO"
  },
  {
    label: "Pedido",
    value: "PEDIDO"
  },
  {
    label: "Todos",
    value: "TODOS"
  }
]



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/utils/filterConstants.js